document.addEventListener('DOMContentLoaded', function() {
  console.log('Predictive search script loaded');
  
  const searchInput = document.getElementById('search-input');
  const resultsContainer = document.getElementById('predictive-search-results');
  if (!searchInput || !resultsContainer) {
    console.error('Search elements not found on page');
    return;
  }
  
  console.log('Search elements found');
  
  let searchTimeout = null;
  searchInput.addEventListener('input', function() {
    const term = this.value.trim();
    clearTimeout(searchTimeout);
    if (term.length === 0) {
      resultsContainer.style.display = 'none';
      return;
    }
    
    searchTimeout = setTimeout(function() {
      resultsContainer.innerHTML = '<p>Searching...</p>';
      resultsContainer.style.display = 'block';
      
      fetch(`/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product`)
        .then(response => response.json())
        .then(data => {
          console.log('Search results:', data);
          const products = data.resources.results.products || [];
          if (products.length === 0) {
            resultsContainer.innerHTML = '<p>No products found</p>';
            return;
          }
          let html = '<ul class="predictive-search-list">';
          
          products.forEach(product => {
            html += `
              <li class="predictive-search-item">
                <a href="${product.url}" class="predictive-search-link">
                  ${product.image ? `<img src="${product.image}" alt="${product.title}" class="predictive-search-image">` : ''}
                  <div class="predictive-search-info">
                    <span class="predictive-search-title">${product.title}</span>
                    <span class="predictive-search-price">${product.price}</span>
                  </div>
                </a>
              </li>
            `;
          });
          
          html += '</ul>';
          resultsContainer.innerHTML = html;
        })
        .catch(error => {
          console.error('Error fetching search results:', error);
          resultsContainer.innerHTML = '<p>Error loading results</p>';
        });
    }, 300);
  });
  
  document.addEventListener('click', function(event) {
    if (!searchInput.contains(event.target) && !resultsContainer.contains(event.target)) {
      resultsContainer.style.display = 'none';
    }
  });
  
  searchInput.addEventListener('focus', function() {
    if (this.value.trim().length > 0 && resultsContainer.innerHTML.trim() !== '') {
      resultsContainer.style.display = 'block';
    }
  });
});
